import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)
Vue.directive('tooltip', VTooltip.VTooltip)

import VueSweetalert2 from 'vue-sweetalert2'
Vue.use(VueSweetalert2);

import CountryFlag from 'vue-country-flag'
Vue.component('country-flag', CountryFlag)

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import VueNativeSock from 'vue-native-websocket'

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
Vue.use(VuePlyr, {
  plyr: {
    hideControls: true,
    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
  }
})

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: {
    id: "G-3SMTD7RPV3"
  },
  appName: 'Tospaa Code Challenge - Multiplayer Coding Game',
  pageTrackerScreenviewEnabled: true
}, router);

//TODO change this before upload
Vue.use(
  VueNativeSock, 'wss://game.tospaa.org/app', {
  //VueNativeSock, 'wss://app.tospaa.org/ws', {
    //VueNativeSock, 'ws://192.168.1.4:15692', {
    //VueNativeSock, 'ws://localhost:15692', {
    store: store,
    format: 'json',
    reconnection: true,
    reconnectionAttempts: 500,
    reconnectionDelay: 300,
  }
)

import titleComponent from './components/title.component.vue';
Vue.component('vue-title', titleComponent);

new Vue({
  router,
  store,
  render: h => h(App),
  watch: {
    '$route': {
      handler: () => {
        /*
                window.onmousemove = function(e){
        
                  var ang = Math.atan2(e.clientX - document.getElementById("tospaaChar").offsetLeft, e.clientY - document.getElementById("tospaaChar").offsetTop);
                  var nX = Math.sin(ang);
                  var nY = Math.cos(ang);
                  console.log(e.clientX);
                  document.getElementById("tospaaP04").style.marginLeft = nX * 12 + "px";
                  document.getElementById("tospaaP04").style.marginBottom = -nY * 12 + "px";
        
                  document.getElementById("tospaaP03").style.marginLeft = nX*4 + "px";
                  document.getElementById("tospaaP03").style.marginBottom = -nY*4 + "px";
        
                  document.getElementById("tospaaP02").style.marginLeft = nX*2 + "px";
                  document.getElementById("tospaaP02").style.marginBottom = -nY*2 + "px";
        
                };
        */
      },
      immediate: true
    }
  },


}).$mount('#app')